module.exports = __webpack_public_path__ + "static/media/gift-tech.fw.8eed1004.png";